import React from 'react'
//@ts-ignore
import { useUserConfig, colors } from 'shared'
import { translate } from '../../helpers'

const AccSearchHint = () => {
  //@ts-ignore
  const { isAccountSearchLimit, top }: { isAccountSearchLimit: boolean; top: number } = useUserConfig([
    'SearchLimit.Account as isAccountSearchLimit',
    'SearchLimit.Top as top',
  ])

  if (!isAccountSearchLimit || top <= 0) {
    return null
  }

  return (
    <div
      style={{
        margin: 'auto',
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center',
        boxShadow: '0px 5px 5px rgba(0,0,0,0.4)',
        border: `1px solid ${colors.red}`,
        color: colors.red,
      }}
    >
      {translate('lbl_top_rec_t').replace('%d', top.toString())}
    </div>
  )
}

export default AccSearchHint
